import request from "@/utils/request";
import { apiConfig } from "../config/api";

// 代理商分页列表
export function getAgentPager(req, pager) {
  return request({
    url: apiConfig.agentInfo.api.pager.url,
    method: "post",
    data: {
      agentName: req.agentName,
      contactName: req.contactName,
      status: req.status,
      startDate: req.startDate,
      endDate: req.endDate,
      page: pager.page,
      pageSize: pager.pageSize
    }
  });
}

// 代理商分页列表搜索功能
export function searchAgentPager(req, pager) {
  return request({
    url: apiConfig.agentInfo.api.pager.url,
    method: "post",
    data: {
      agentName: req.agentName,
      contactName: req.contactName,
      status: req.status,
      startDate: req.startDate,
      endDate: req.endDate,
      page: pager.page,
      pageSize: pager.pageSize
    }
  });
}
// 查询代理商信息
export function findAgentById(agentId) {
  return request({
    url: apiConfig.agentInfo.api.find.url,
    method: "get",
    params: {
      agentId: agentId
    }
  });
}
// 更新代理商信息
export function updateAgent(req) {
  return request({
    url: apiConfig.agentInfo.api.edit.url,
    method: "post",
    data: {
      agentId: req.agentId,
      agentName: req.agentName,
      agentCode: req.agentCode,
      contactName: req.contactName,
      contactPhone: req.contactPhone,
      email: req.email,
      website: req.website,
      businessDirection: req.businessDirection,
      scope: req.scope,
      projectSpecialty: req.projectSpecialty,
      about: req.about,
      remarks: req.remarks
    }
  });
}
// 查询代理商项目列表
export function getProjectList(req) {
  return request({
    url: apiConfig.agentInfo.api.getProjectList.url,
    method: "post",
    data: {
      agentId: req.agentId,
      page: req.page,
      pageSize: req.pageSize
    }
  });
}
// 暂停代理商
export function suspendAgent(req) {
  return request({
    url: apiConfig.agentInfo.api.suspend.url,
    method: "post",
    data: {
      agentId: req.agentId,
      status: req.status
    }
  });
}
// 删除代理商
export function deleteAgent(req) {
  return request({
    url: apiConfig.agentInfo.api.delete.url,
    method: "post",
    data: {
      agentId: req.agentId,
      status: req.status
    }
  });
}

// 查询参与项目用户列表
export function getProjectUserPager(req) {
  return request({
    url: apiConfig.agentInfo.api.getProjectUserPager.url,
    method: "post",
    data: {
      projectId: req.projectId,
      page: req.page,
      pageSize: req.pageSize
    }
  });
}

// 查询子代理商列表
export function getSubAgentList(req) {
  return request({
    url: apiConfig.agentInfo.api.getSubAgentList.url,
    method: "post",
    data: {
      agentId: req.agentId,
      page: req.page,
      pageSize: req.pageSize
    }
  });
}
// 根据代理商名称模糊查询代理商列表
export function getAgentByName(agentName) {
  return request({
    url: apiConfig.agentInfo.api.getAgentByName.url,
    method: "get",
    params: {
      agentName: agentName
    }
  });
}

// 查询代理商列表
export function getAgentList() {
  return request({
    url: apiConfig.agentInfo.api.agentList.url,
    method: "get"
  });
}

// 查询可绑定的父代理商列表
export function getParentAgentList(param) {
  return request({
    url: apiConfig.agentInfo.api.getParentAgentList.url,
    method: "get",
    params: param
  });
}
export function getAgentCount() {
  return request({
    url: apiConfig.agentStatistics.api.getAgentCount.url,
    method: "get"
  });
}

export function getAgentUserSex(req) {
  return request({
    url: apiConfig.agentStatistics.api.getAgentUserSex.url,
    method: "get",
    params: {
      agentId: req.agentId
    }
  });
}
export function getAgentUserLevel(req) {
  return request({
    url: apiConfig.agentStatistics.api.getAgentUserLevel.url,
    method: "get",
    params: {
      agentId: req.agentId
    }
  });
}

export function getAgentProjectUserCount(req) {
  return request({
    url: apiConfig.agentStatistics.api.getAgentProjectUserCount.url,
    method: "get",
    params: {
      agentId: req.agentId
    }
  });
}
